import { render, staticRenderFns } from "./GlobalSmallSpotlight.vue?vue&type=template&id=a26e2b3e&scoped=true"
import script from "./GlobalSmallSpotlight.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalSmallSpotlight.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GlobalSmallSpotlight.vue?vue&type=style&index=0&id=a26e2b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a26e2b3e",
  null
  
)

export default component.exports